/* eslint-disable import/no-extraneous-dependencies */
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { createLogicMiddleware } from 'redux-logic'
import reduxThunk from 'redux-thunk'

import logic from './logic'
import createRootReducer from './reducers'

const logicMiddleware = createLogicMiddleware(logic as any)

export const history = createBrowserHistory()

export default createStore(
  createRootReducer(history),
  composeWithDevTools(applyMiddleware(reduxThunk, logicMiddleware, routerMiddleware(history))),
)
